import styled, { createGlobalStyle } from 'styled-components';
import { COLORS } from 'constants/colors';

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    background-color: ${({ color }) => color};
    height: 100%;
    width: 100%;
    font-family: 'Inter', sans-serif;
  }

  * {
    font-family: 'Inter', sans-serif;
  }
`;

export const PageWrapper = styled.div`
  background-color: ${COLORS.black};
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
`;
